import React from "react";
import {Col, Row, Card, Button, Icon} from "antd";
import paymentReportApi from '@api/payment-report'
import PurchasesReportSearch from '@components/payments/dashboard/Search';
import PaymentChart from '@components/payments/dashboard/PaymentChart';
import CountChart from '@components/payments/dashboard/CountChart';
import ReportList from '@components/payments/dashboard/List';
import {useSelector} from "react-redux";
import {getMainClientId} from "../../components/clients/selectors";
import whitListData from "../../hocs/withListData";
import withPaginationComponent from "../../hocs/withPaginationComponent";




function useListFilter() {
  const client_id = useSelector(getMainClientId);
  return {
    client_id,
  }
}


function PaymentReportDashboardPage(props) {
  const { data, isFetched, search} = props;
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <PurchasesReportSearch search={search}/>
        </Card>
      </Col>
      
      <Col span={24}>
        {data.length > 0 && (
          <Row gutter={12}>
            <Col span={12}>
              <PaymentChart data={data}/>
            </Col>
  
            <Col span={12}>
              <CountChart data={data}/>
            </Col>
          </Row>
        )}
        
        <ReportList
          loading={!isFetched}
          data={data}/>
      </Col>
    </Row>
  )
}



export default whitListData(
  withPaginationComponent(PaymentReportDashboardPage),
  {
    fetchRequest: paymentReportApi.getAllPaymentsReport,
    paginationOnScroll: false,
    useFilter: useListFilter
  }
);
